import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const TAB_GROUPS = [
  { id: "orders", label: "Orders", tabs: ["orders", "polaris", "batches", "pay-approvals", "quotes"] },
  { id: "customers", label: "Customers", tabs: ["agencies", "private-customers", "tax-exempt", "partnerships"] },
  { id: "menu-site", label: "Menu & Site", tabs: ["menu", "packages", "gallery", "holiday"] },
  { id: "team-tools", label: "Team & Tools", tabs: ["hiring", "newsletter", "storage", "activity"] },
];

const CountBadge = ({ count, dark }) =>
  count == null ? null : (
    <span
      className={`ml-auto inline-flex items-center justify-center rounded-full px-1.5 py-0.5 text-[9.5px] font-bold ${
        dark ? "bg-brand-charcoal text-white" : "bg-brand-charcoal/10 text-brand-charcoal/60"
      }`}
    >
      {count}
    </span>
  );

const GroupMenu = ({ group, tabsById, tab, setTab, getCount }) => {
  const activeTab = group.tabs.includes(tab) ? tabsById[tab] : null;
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid={`admin-tab-group-${group.id}`}
          className={`relative inline-flex items-center gap-1.5 px-3.5 py-2.5 text-[12px] font-bold uppercase tracking-[0.08em] whitespace-nowrap transition-colors outline-none ${
            activeTab ? "text-brand-charcoal" : "text-brand-charcoal/50 hover:text-brand-charcoal/80"
          }`}
        >
          {group.label}
          {activeTab && (
            <span className="normal-case tracking-normal font-semibold text-brand-teal">· {activeTab.label}</span>
          )}
          <ChevronDown className="h-3.5 w-3.5" />
          {activeTab && <span className="absolute bottom-0 left-0 right-0 h-[2px] bg-brand-teal" />}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[220px] rounded-xl">
        {group.tabs.map((id) => {
          const t = tabsById[id];
          const active = tab === id;
          return (
            <DropdownMenuItem
              key={id}
              data-testid={`admin-tab-${id}`}
              onSelect={() => setTab(id)}
              className={`gap-2 cursor-pointer text-[13px] font-semibold ${active ? "bg-brand-teal/10 text-brand-teal" : ""}`}
            >
              <t.icon className="h-3.5 w-3.5" />
              {t.label}
              <CountBadge count={getCount(id)} dark={active} />
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const AdminTabGroups = ({ tabs, tab, setTab, getCount }) => {
  const tabsById = Object.fromEntries(tabs.map((t) => [t.id, t]));
  return (
    <div data-testid="admin-tab-groups" className="hidden sm:flex flex-wrap items-center gap-1 border-b border-black/10">
      {TAB_GROUPS.map((g) => (
        <GroupMenu key={g.id} group={g} tabsById={tabsById} tab={tab} setTab={setTab} getCount={getCount} />
      ))}
    </div>
  );
};
